import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import config from "./config";
import { GoogleOAuthProvider } from "@react-oauth/google";
import * as Sentry from "@sentry/react";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import "./index.css";

//TODO: disable sentry for now and add this in build package.json
// "build": "react-scripts build && npm run sentry:sourcemaps"
    
// Sentry.init({
//   dsn: config.sentryDsn,
//   integrations: [],
//   // Setting this option to true will send default PII data to Sentry.
//   // For example, automatic IP address collection on events
//   sendDefaultPii: true,
// });
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <GoogleOAuthProvider clientId={config.googleAuthClientId}>
      <App />
    </GoogleOAuthProvider>
  </Provider>
);

//TODO: check this shit
reportWebVitals();
